import { actionTypes } from 'BASE/store/types';
import { storage } from 'BASE/common/util/util.storage';

export default {
    data: function () {
        return {
            showSkinBar: true,
        }
    },
    watch: {
        skinColor: {
            immediate: true,
            handler(skin) {
                this.setBodySkinClass(skin);
            },
        },
        $route(to, from) {
            if (to.name == 'Home' || to.name == 'Bet' || to.name == 'MultiBet') {
                this.showSkinBar = true;
                this.setBodySkinClass(this.skinColor);
            } else {
                this.showSkinBar = false;
                this.setBodySkinClass('');
            }
        }
    },
    computed: {
        skinColor() {
            return this.$store.state.userinfo.skinClass;
        },
    },
    methods: {
        async changeSkin(skin) {
            storage.local.set(storage.keys.SKIN_COLOR, skin);
            await this.$store.dispatch(actionTypes.USER_INFO_SKIN_COLOR, { skinClass: skin });
        },
        setBodySkinClass(skin) {
            if (skin == 'block') {
                document.body.className = `color5`;
            } else {
                document.body.className = ``;
            }
        },
    },
    async mounted() {
        let skinColor = storage.local.get(storage.keys.SKIN_COLOR) || 'green';
        await this.$store.dispatch(actionTypes.USER_INFO_SKIN_COLOR, { skinClass: skinColor });
    },
};
